export default "__VITE_ASSET__$J17AfXU__"